var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!!_vm.middleBanner)?_c('Banner',{attrs:{"imageList":_vm.bannerImages,"type":"home"}}):_c('ContentLoading',{attrs:{"type":"banner"}}),(!_vm.hideCondition)?_c('Footer',{attrs:{"page":"home"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }